import { render } from "./NavBar.vue?vue&type=template&id=39b709be&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=39b709be&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b709be"]])

export default __exports__